
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 139 93"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","fill":"#F0F0F0","d":"M69.495.338C32.013.338-.001 46.669-.001 46.669S31.992 93 69.495 93c37.483 0 69.496-46.331 69.496-46.331S106.999.338 69.495.338zm0 81.079c-21.627 0-43.831-21.208-55.017-34.748 11.157-13.545 33.305-34.748 55.017-34.748 21.627 0 43.831 21.208 55.018 34.748-11.157 13.545-33.305 34.748-55.018 34.748zm23.166-34.748c0-12.794-10.372-23.165-23.166-23.165S46.33 33.875 46.33 46.669c0 12.794 10.371 23.165 23.165 23.165 12.794 0 23.166-10.371 23.166-23.165M69.495 58.252c-7.097 0-11.582-4.487-11.582-11.583s4.485-11.583 11.582-11.583c7.096 0 11.583 4.487 11.583 11.583s-4.487 11.583-11.583 11.583z"}})])
          )
        }
      }
    